
/* Landing page behaviour for the lp_vacuum_bogo-memorial section. */
(() => {
  const initSection = dataEl => {
    if (dataEl.dataset.lpReady === '1') return;
    dataEl.dataset.lpReady = '1';

    const SECTION_ID = dataEl.dataset.sectionId;
    const root = document.getElementById('shopify-section-' + SECTION_ID) || document;

    let DATA;
    try { DATA = JSON.parse(dataEl.textContent); } catch (e) { return; }
    const variants = DATA.variants || [];

    const q  = sel => root.querySelector(sel);
    const qa = sel => Array.from(root.querySelectorAll(sel));

    /* ---------- money ---------- */
    const sample = (variants.find(v => v.priceText) || {}).priceText || '$0';
    const symbol = (sample.match(/^[^\d]*/) || [''])[0];
    const suffix = (sample.match(/[^\d.,\s]*$/) || [''])[0];
    const fmt = cents => symbol + Math.round(cents / 100) + (suffix === symbol ? '' : suffix);

    /* Shopify money_format, so computed totals match the store/market exactly. */
    const moneyFormat = DATA.moneyFormat || '${{amount}}';
    const tidy = s => s.replace(/([.,])00(\D*)$/, '$2');
    const formatMoney = cents => {
      const n = Number(cents) / 100;
      const build = (dec, sep) => {
        const p = n.toFixed(dec).split('.');
        p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, sep === ',' ? '.' : ',');
        return dec ? p.join(sep) : p[0];
      };
      return tidy(moneyFormat
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, build(0, ','))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, build(2, ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, build(0, '.'))
        .replace(/\{\{\s*amount\s*\}\}/g, build(2, '.')));
    };

    const ourIds = new Set(variants.map(v => v.id));
    const kachingEl = () => document.querySelector('kaching-bundle');

    /* Kaching renders its own prices for the selected deal (its discount is not
       a variant price, so it cannot be derived from Shopify data). Mirror them
       when present; otherwise fall back to variant price x quantity. */
    const kachingPrices = () => {
      const k = kachingEl(); if (!k) return null;
      // Kaching marks the active deal with a --selected class and only checks a
      // radio once the shopper clicks, so the class is the reliable source.
      const checked = k.querySelector('input:checked');
      let bar = k.querySelector('.kaching-bundles__bar--selected');
      if (!bar && checked) {
        const esc = window.CSS && CSS.escape ? CSS.escape(checked.id) : checked.id;
        bar = checked.closest('.kaching-bundles__bar')
          || (checked.id ? document.querySelector('label[for="' + esc + '"]') : null)
          || checked.parentElement;
      }
      if (!bar) return null;
      const money = [...bar.querySelectorAll('*')]
        .filter(e => !e.children.length)
        .map(e => e.textContent.trim())
        .filter(t => /\d/.test(t) && /^[^\d]{0,4}\d[\d.,\s]*[^\d]{0,4}$/.test(t) && !/^\d+$/.test(t));
      return money.length ? { priceText: money[0], compareText: money[1] || '' } : null;
    };

    /* The product form Kaching writes its quantity into - matched by variant id
       so we never pick up a recommendation form for another product. */
    const cartForm = () => [...document.querySelectorAll('form[action*="/cart/add"]')]
      .find(f => { const i = f.querySelector('[name="id"]'); return i && ourIds.has(Number(i.value)); });

    const getSelection = () => {
      const card = root.querySelector('.bundle.selected');
      if (card && card.dataset.variant) {
        const v = variants.find(x => x.id === Number(card.dataset.variant));
        if (v) return { id: v.id, qty: 1, priceText: v.priceText,
                        compareText: v.compare > v.price ? v.compareText : '' };
      }
      const f = cartForm();
      const qEl = f && f.querySelector('[name="quantity"]');
      let id = f ? Number(f.querySelector('[name="id"]').value) : null;
      const qty = qEl ? (parseInt(qEl.value, 10) || 1) : 1;
      if (!id) { const v = variants.find(x => (!currentColor || x.color === currentColor) && x.available); id = v && v.id; }
      const base = variants.find(x => x.id === id);
      if (!id || !base) return null;
      const kp = kachingPrices();
      return {
        id, qty,
        priceText: (kp && kp.priceText) || (qty === 1 ? base.priceText : formatMoney(base.price * qty)),
        compareText: (kp && kp.compareText) ||
          (base.compare > base.price ? (qty === 1 ? base.compareText : formatMoney(base.compare * qty)) : '')
      };
    };

    /* ---------- FAQ accordion ---------- */
    qa('.faq-item').forEach(item => {
      item.addEventListener('click', () => {
        item.classList.toggle('open');
        const ans = item.nextElementSibling;
        if (ans && ans.classList.contains('faq-answer')) ans.classList.toggle('open');
      });
    });

    /* ---------- Tabs ---------- */
    const tabs = qa('.tab');
    const panels = qa('.tab-panel');
    tabs.forEach(t => {
      t.addEventListener('click', () => {
        tabs.forEach(x => x.classList.remove('active'));
        panels.forEach(p => p.classList.remove('active'));
        t.classList.add('active');
        const panel = q('#panel-' + t.dataset.tab);
        if (panel) panel.classList.add('active');
      });
    });

    /* ---------- Colour + bundle (variant) selection ---------- */
    const bundles = qa('.bundle');
    const swatches = qa('.lp-swatch');
    const priceOld = q('#priceOld');
    const priceNew = q('#priceNew');
    const priceOldMobile = q('#priceOldMobile');
    const priceNewMobile = q('#priceNewMobile');
    const heroImg = q('#heroImg');
    const heroThumb = q('#thumbs .thumb[data-index="0"] img');

    let currentColor = swatches.length ? swatches[0].dataset.color : (variants[0] ? variants[0].color : '');

    const findVariant = (color, pack) => variants.find(v =>
      (!color || v.color === color) && (!pack || v.pack === pack)
    );

    const setText = (el, txt) => { if (el) el.textContent = txt || ''; };

    const refreshBundle = b => {
      const v = findVariant(currentColor, b.dataset.pack);
      const bags = Math.max(1, parseInt(b.dataset.bags || '1', 10));
      const newEl = b.querySelector('.price-line .new');
      const oldEl = b.querySelector('.price-line .old');
      const perKit = b.querySelector('.price-line .per-kit');
      const perUnit = !!perKit;

      if (!v) {
        b.classList.add('unavailable');
        b.dataset.variant = ''; b.dataset.cart = '';
        return;
      }
      b.classList.toggle('unavailable', v.available === false);
      b.dataset.variant = v.id;
      b.dataset.cart = v.id + ':1';
      b.dataset.price = v.price;
      b.dataset.compare = (v.compare > v.price) ? v.compare : '';

      setText(newEl, fmt(perUnit ? v.price / bags : v.price));
      if (oldEl) {
        if (v.compare > v.price) {
          oldEl.style.display = '';
          setText(oldEl, fmt(perUnit ? v.compare / bags : v.compare));
        } else {
          oldEl.style.display = 'none';
        }
      }
    };

    const refreshClaim = () => {
      const s = getSelection();
      if (!s) return;
      setText(priceNew, s.priceText); setText(priceOld, s.compareText);
      setText(priceNewMobile, s.priceText); setText(priceOldMobile, s.compareText);
      [priceOld, priceOldMobile].forEach(el => { if (el) el.style.display = s.compareText ? '' : 'none'; });
    };

    const refreshAll = () => { bundles.forEach(refreshBundle); refreshClaim(); };

    bundles.forEach(b => {
      b.addEventListener('click', () => {
        if (b.classList.contains('unavailable')) return;
        bundles.forEach(x => x.classList.remove('selected'));
        b.classList.add('selected');
        refreshClaim();
        const btn = q('#claimBtn');
        if (btn) { btn.style.transform = 'scale(1.02)'; setTimeout(() => { btn.style.transform = ''; }, 150); }
      });
    });

    swatches.forEach(sw => {
      sw.addEventListener('click', () => {
        swatches.forEach(x => x.classList.remove('active'));
        sw.classList.add('active');
        currentColor = sw.dataset.color;
        setText(q('#lpColorName'), currentColor);
        refreshAll();
        const sel = q('.bundle.selected') || bundles[0];
        let v = sel ? findVariant(currentColor, sel.dataset.pack) : null;
        // app-block mode has no bundle cards, so fall back to any variant in
        // this colour that has its own photo
        if (!v || !v.image) {
          v = variants.find(x => x.color === currentColor && x.image) || v;
        }
        const img = (v && v.image) ? v.image : null;
        if (img && heroImg) heroImg.src = img;
        if (img && heroThumb) heroThumb.src = img;
      });
    });

    if (variants.length) { refreshAll(); refreshClaim(); }

    /* ---------- Carousel ---------- */
    const track = q('#track');
    if (track) {
      const slides = track.querySelectorAll('.slide');
      const thumbs = qa('#thumbs .thumb');
      const prevBtn = q('#prevBtn');
      const nextBtn = q('#nextBtn');
      let current = 0;
      const heroVideo = q('#heroVideo');
      const videoSlideIndex = heroVideo ? 1 : -1;

      const goTo = i => {
        current = (i + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-current * 100) + '%)';
        thumbs.forEach((t, idx) => t.classList.toggle('active', idx === current));
        if (heroVideo) {
          if (current === videoSlideIndex) { const p = heroVideo.play(); if (p && p.catch) p.catch(() => {}); }
          else heroVideo.pause();
        }
      };

      thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
      if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
      if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

      let startX = 0, dx = 0, dragging = false;
      track.addEventListener('touchstart', e => { startX = e.touches[0].clientX; dragging = true; dx = 0; }, { passive: true });
      track.addEventListener('touchmove',  e => { if (dragging) dx = e.touches[0].clientX - startX; }, { passive: true });
      track.addEventListener('touchend', () => {
        if (!dragging) return;
        if (Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
        dragging = false;
      });

      document.addEventListener('keydown', e => {
        const rect = track.getBoundingClientRect();
        if (!(rect.top < window.innerHeight && rect.bottom > 0)) return;
        if (e.key === 'ArrowLeft') goTo(current - 1);
        else if (e.key === 'ArrowRight') goTo(current + 1);
      });
    }

    /* ---------- Sticky CTA on scroll ---------- */
    const sticky = q('#stickyCta');
    const hero = q('.hero');
    if (sticky && hero) {
      const onScroll = () => {
        const heroBottom = hero.offsetTop + hero.offsetHeight - 200;
        sticky.classList.toggle('show', window.scrollY > heroBottom);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }

    /* ---------- Smooth-scroll claim buttons ---------- */
    qa('[data-jump="claim"]').forEach(b => {
      b.addEventListener('click', () => {
        const target = q('#claimBtn') || q('.lp-app-bundle') || q('#bundles');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });

    /* ---------- Add to cart ---------- */
    let busy = false;
    const buyNow = async () => {
      const s = getSelection();
      if (!s || busy) return;
      busy = true;
      try {
        const addUrl = ((window.routes && window.routes.cart_add_url) || DATA.cartAddUrl || '/cart/add') + '.js';
        const res = await fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: s.id, quantity: s.qty }] })
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'add to cart failed');

        if (DATA.cartRedirect === 'checkout') { window.location.href = '/checkout'; return; }
        if (DATA.cartRedirect === 'cart') { window.location.href = DATA.cartUrl || '/cart'; return; }
        // stay on the page and let the theme open its cart drawer
        if (typeof window.publish === 'function') {
          window.publish('cart:added', { items: data.items, quantity: s.qty });
        } else {
          window.location.href = DATA.cartUrl || '/cart';
        }
      } catch (e) {
        // last resort: the permalink add still works without JS
        window.location.href = '/cart/' + s.id + ':' + s.qty;
      } finally {
        busy = false;
      }
    };
    qa('.claim-btn').forEach(b => b.addEventListener('click', buyNow));

    /* keep the button in sync with Kaching's selection */
    document.addEventListener('change', e => {
      if (e.target.closest && e.target.closest('kaching-bundle')) setTimeout(refreshClaim, 80);
    });
    document.addEventListener('click', e => {
      if (e.target.closest && e.target.closest('kaching-bundle')) setTimeout(refreshClaim, 220);
    });
    setTimeout(refreshClaim, 1200);
    setTimeout(refreshClaim, 3000);

    // Kaching swaps the --selected class without firing a form event
    let kachingWatch = null;
    const watchKaching = () => {
      const k = kachingEl();
      if (!k || kachingWatch) return;
      kachingWatch = new MutationObserver(() => refreshClaim());
      kachingWatch.observe(k, { subtree: true, attributes: true, attributeFilter: ['class', 'checked'] });
      refreshClaim();
    };
    watchKaching();
    const kachingPoll = setInterval(() => { watchKaching(); if (kachingWatch) clearInterval(kachingPoll); }, 500);
    setTimeout(() => clearInterval(kachingPoll), 15000);

    /* ---------- Countdown ---------- */
    const dd = q('#dd'), hh = q('#hh'), mm = q('#mm'), ss = q('#ss'), endsIn = q('#endsIn');
    if (dd || endsIn) {
      let total = (DATA.countdownHours || 0) * 3600 + (DATA.countdownMinutes || 0) * 60;
      const pad = n => String(n).padStart(2, '0');
      const tick = () => {
        const d = Math.floor(total / 86400);
        const h = Math.floor((total % 86400) / 3600);
        const m = Math.floor((total % 3600) / 60);
        const sec = total % 60;
        setText(dd, pad(d)); setText(hh, pad(h)); setText(mm, pad(m)); setText(ss, pad(sec));
        if (endsIn) endsIn.textContent = pad(h) + ':' + pad(m) + ':' + pad(sec);
      };
      tick();
      setInterval(() => { if (total > 0) { total--; tick(); } }, 1000);
    }

    /* ---------- Ship date ---------- */
    const ship = new Date();
    ship.setDate(ship.getDate() + (DATA.shipDaysAhead || 1));
    const days = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    const shipStr = days[ship.getDay()] + ', ' + months[ship.getMonth()] + ' ' + ship.getDate();
    setText(q('#shipDate'), shipStr);
    setText(q('#shipDateSticky'), shipStr);
  };

  const boot = scope => (scope || document)
    .querySelectorAll('script[type="application/json"][data-lp-data]')
    .forEach(initSection);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', e => boot(e.target));
})();
